import languagesData from "../../../../data/languages.json" // eslint-disable-line import/no-restricted-paths

const routesLangs = {
  de: {
    airlines: "Fluggesellschaften",
    airline: "Fluggesellschaften",
    browse: "Durchsuchen",
    flights: "Fluge",
    airports: "Flughafen",
    airport: "Flughafen",
    airportHotels: "Flughafenhotels",
    country: "Land",
    news: "Neuigkeiten",
    dealsFrom: "Angebote/ab",
    deals: "Angebote",
    archive: "Archiv",
    tags: "Markieren",
    aboutWhichAirline: "Uber-whichairline",
    privacyPolicy: "Datenschutzrichtlinien",
    contactUs: "Kontakt",
    legal: "Rechtliche-Hinweise",
    mediakit: "mediakit",
    advertise: "Werben",
    support: "Hilfe",
    faq: "faq",
    jobs: "Arbeitsplatze",
    rss: "rss",
    tag: "Markieren",
    press: "Presse",
    unsubscribe: "Abbestellen",
    search: "Suche",
    airlinesSearch: "Suche-nach-Fluggesellschaften",
    airportsSearch: "Suche-nach-Flughafen",
    newsSearchResult: "Neuigkeiten-Suchergebniss",
  },

  bg: {
    airlines: "aviokompanii",
    airline: "aviokompaniya",
    airlinesSearch: "aviokompanii-tarsene",
    browse: "razglejdane",
    flights: "poleti",
    airports: "letishta",
    airportHotels: "khoteli-letishte",
    airport: "letishte",
    country: "darjava",
    airportsSearch: "letishta-tarsene",
    dealsFrom: "promocii/ot",
    deals: "promocii",
    news: "novini",
    archive: "arhiv",
    tags: "etiketi",
    newsSearchResult: "novini-tarsene-rezultat",
    aboutWhichairline: "za-whichairline",
    privacyPolicy: "lichni-danni-politika",
    contactUs: "svarjete-se-s-nas",
    legal: "lpravna-informatsiya",
    advertise: "reklama",
    support: "pomosht",
    mediakit: "mediakit",
    faq: "chzv",
    jobs: "rabota",
    rss: "emisii",
    tag: "etiket",
    press: "presa",
    unsubscribe: "otpisvane",
    search: "tarsene",
  },
  bz: {
    airlines: "companhias-aereas",
    airline: "companhia-aerea",
    airlinesSearch: "companhias-aereas-pesquisar",
    browse: "pesquisar",
    flights: "voos",
    airports: "aeroportos",
    airport: "aeroporto",
    airportHotels: "hoteis-de-aeroporto",
    country: "pais",
    airportsSearch: "aeroportos-pesquisar",
    dealsFrom: "promocoes/de",
    deals: "promocoes",
    news: "noticias",
    archive: "arquivo",
    tags: "tags",
    newsSearchResult: "noticias-pesquisar-resultado",
    aboutWhichairline: "sobre-whichairline",
    privacyPolicy: "politica-de-privacidade",
    contactUs: "entre-em-contato",
    legal: "termos-e-condicoes",
    mediakit: "mediakit",
    advertise: "anuncie",
    support: "ajuda",
    faq: "perguntas-frequentes",
    jobs: "empregos",
    rss: "rss",
    tag: "tag",
    press: "imprensa",
    unsubscribe: "cancelar-recebimento",
    search: "pesquisar",
  },
  ca: {
    airlines: "aerolinies",
    airline: "aerolinia",
    browse: "explorar",
    flights: "vols",
    airports: "aeroports",
    airport: "aeroport",
    airportHotels: "hotels-de-l-aeroport",
    country: "pais",
    dealsFrom: "ofertes/desde",
    deals: "ofertes",
    news: "noticies",
    archive: "arxiu",
    tags: "etiquetes",
    aboutWhichairline: "qui-som-whichairline",
    privacyPolicy: "politica-de-privacitat",
    contactUs: "contacte",
    legal: "avis-legal",
    mediakit: "mediakit",
    advertise: "publicitat",
    support: "ajuda",
    faq: "preguntes-mes-frequents",
    jobs: "feina",
    rss: "rss",
    tag: "etiqueta",
    press: "premsa",
    unsubscribe: "cancel-lar-subscripcio",
    search: "cerca",
    airlinesSearch: "aerolinies-cercar",
    airportsSearch: "aeroports-cercar",
    newsSearchResult: "noticies-cerca-resultat",
  },
  en: {
    advertise: "advertise",
    airline: "airlines", //! !! en airline translated to airlines - it is like that on WA, don't know why
    airlines: "airlines",
    airlinesSearch: "airlinesSearch",
    airport: "airport",
    airportHotels: "airportHotels",
    airports: "airports",
    airportsSearch: "airportsSearch",
    aboutWhichAirline: "about-whichairline",
    archive: "archive",
    browse: "browse",
    contactUs: "contactUs",
    content: "content",
    country: "country",
    deals: "deals",
    dealsFrom: "deals/from",
    faq: "faq",
    flights: "cheap-flights",
    hotels: "hotels",
    jobs: "jobs",
    legal: "legal",
    mediakit: "mediakit",
    news: "news",
    newsSearchResult: "newsSearchResult",
    press: "press",
    privacyPolicy: "privacyPolicy",
    rss: "rss",
    search: "search",
    searchDetail: "search-detail",
    customSearch: "custom-search",
    support: "support",
    tag: "tag",
    tags: "tags",
    unsubscribe: "unsubscribe",
    multicity: "multicity",
  },
  cs: {
    airlines: "letecke-spolecnosti",
    airline: "letecka-spolecnost",
    browse: "pismena",
    flights: "letenky",
    airports: "letiste",
    airport: "letiste",
    airportHotels: "hotely-u-letiste",
    country: "zeme",
    dealsFrom: "akcni-letenky/z",
    deals: "akcni-letenky",
    news: "novinky",
    archive: "archiv",
    tags: "kategorie!",
    aboutWhichairline: "o-whichairline",
    privacyPolicy: "ochrana-osobnich-udaju",
    contactUs: "kontaktujte-nas",
    legal: "pravni-otazky",
    mediakit: "mediakit",
    advertise: "inzerce",
    support: "podpora",
    faq: "faq",
    jobs: "nabidka-prace",
    rss: "rss",
    tag: "kategorie",
    press: "press",
    unsubscribe: "unsubscribe",
    search: "hledej",
    searchDetail: "detail-hledani",
    airlinesSearch: "vyhledavani-leteckych-spolecnosti",
    airportsSearch: "vyhledavani-letist",
    newsSearchResult: "vyhledavani-novinek",
  },
  da: {
    airlines: "flyselskaber",
    airline: "flyselskab",
    browse: "gennemse",
    flights: "flyafgange",
    airports: "lufthavne",
    airport: "lufthavn",
    airportHotels: "lufthavnshoteller",
    country: "land",
    dealsFrom: "tilbud/fra",
    deals: "tilbud",
    news: "nyheder",
    archive: "arkiv",
    tags: "tags",
    aboutWhichairline: "om-whichairline",
    privacyPolicy: "fortrolighedspolitik",
    contactUs: "kontakt-os",
    legal: "juridisk",
    advertise: "annoncering",
    support: "support",
    faq: "faq",
    jobs: "job",
    mediakit: "mediakit",
    rss: "rss",
    tag: "tag",
    press: "presse",
    unsubscribe: "afmelding",
    search: "sogning",
    airlinesSearch: "flyselskaber-sogning",
    airportsSearch: "lufthavne-sogning",
    newsSearchResult: "nyheds-sogeresultater",
  },
  el: {
    airlines: "etaireies",
    airline: "etaireia",
    browse: "anazitisi",
    flights: "ptiseis",
    airports: "aerodromia",
    airport: "aerodromio",
    airportHotels: "xenodoxeia-aerodromiou",
    country: "xwra",
    dealsFrom: "prosfores/apo",
    deals: "prosfores",
    news: "nea",
    archive: "arxeio",
    tags: "etiketes",
    aboutWhichairline: "sxetikame-whichairline",
    privacyPolicy: "politiki-exemytheias",
    contactUs: "epikoinwnia",
    mediakit: "mediakit",
    legal: "nomika",
    advertise: "diafimisi",
    support: "ypostiriksi",
    faq: "syxnes-erwtiseis",
    jobs: "theseis-ergasias",
    rss: "rss",
    tag: "tag",
    press: "typos",
    unsubscribe: "unsubscribe",
    search: "anazitisi",
    airlinesSearch: "etaireies-anazitisi",
    airportsSearch: "aerodromia-anazitisi",
    newsSearchResult: "nea-anazitisi-apotelesma",
  },
  es: {
    airlines: "aerolineas",
    airline: "aerolinea",
    browse: "explorar",
    flights: "vuelos",
    airports: "aeropuertos",
    airport: "aeropuerto",
    airportHotels: "hoteles-del-aeropuerto",
    country: "pais",
    dealsFrom: "ofertas/desde",
    deals: "ofertas-vuelos",
    news: "noticias",
    archive: "archivo",
    tags: "etiquetas",
    aboutWhichairline: "acerca-de-whichairline",
    privacyPolicy: "politica-de-privacidad",
    contactUs: "contacto",
    legal: "aviso-legal",
    mediakit: "mediakit",
    advertise: "anunciese",
    support: "soporte",
    faq: "faq",
    jobs: "empleo",
    rss: "rss",
    tag: "etiqueta",
    press: "prensa",
    unsubscribe: "cancelar-suscripcion",
    search: "buscar",
    airlinesSearch: "aerolineas-buscar",
    airportsSearch: "aeropuertos-buscar",
    newsSearchResult: "noticias-buscar-resultado",
  },
  fi: {
    airlines: "lentoyhtiot",
    airline: "lentoyhtio",
    browse: "selaa",
    flights: "lennot",
    airports: "lentokentat",
    airport: "lentokentta",
    airportHotels: "lentokenttahotellit",
    country: "maassa",
    dealsFrom: "tarjoukset/kohteesta",
    deals: "tarjoukset",
    news: "uutiset",
    archive: "arkisto",
    tags: "tagit",
    aboutWhichairline: "tietoa-sivustosta",
    privacyPolicy: "tietosuojaseloste",
    contactUs: "ota-yhteytta",
    mediakit: "mediakit",
    legal: "oikeusilmoitus",
    advertise: "mainosta",
    support: "tukki",
    faq: "ukk",
    jobs: "rekry",
    rss: "rss",
    tag: "tagi",
    press: "lehdisto",
    unsubscribe: "peru-tilaus",
    search: "haku",
    airlinesSearch: "lentoyhtiohaku",
    airportsSearch: "lentokenttahaku",
    newsSearchResult: "uutishaun-tulos",
  },
  fr: {
    airlines: "compagnies-aeriennes",
    airline: "compagnie-aerienne",
    browse: "chercher",
    flights: "vols",
    airports: "aeroports",
    airport: "aeroport",
    airportHotels: "hotels-d-aeroports",
    country: "pays",
    dealsFrom: "affaires/de",
    deals: "affaires",
    news: "actualites",
    archive: "archives",
    tags: "mots-cles",
    aboutWhichairline: "a-propos-de-whichairline",
    privacyPolicy: "politique-de-confidentialite",
    contactUs: "nous-contactez",
    legal: "mentions-legales",
    mediakit: "mediakit",
    advertise: "publicite",
    support: "support",
    faq: "faq",
    jobs: "recrutement",
    rss: "rss",
    tag: "mot-cle",
    press: "presse",
    unsubscribe: "desabonnement",
    search: "rechercher",
    airlinesSearch: "rechercher-compagnies-aeriennes",
    airportsSearch: "rechercher-aeroports",
    newsSearchResult: "resultat-de-la-recherche",
  },
  hr: {
    airlines: "zracni-prijevoznici",
    airline: "zracni-prijevoznik",
    browse: "pretrazi",
    flights: "letovi",
    airports: "zracne-luke",
    airport: "zracna-luka",
    airportHotels: "hoteli-blizu-zracne-luke",
    country: "drzava",
    dealsFrom: "posebne-ponude/iz",
    deals: "posebne-ponude",
    news: "novosti",
    archive: "arhiva",
    tags: "oznake",
    aboutWhichairline: "o-akarte",
    privacyPolicy: "pravila-o-privatnosti",
    contactUs: "kontaktirajte-nas",
    legal: "pravne-napomene",
    mediakit: "materijali-za-medije",
    advertise: "oglasavanje",
    support: "podrska",
    faq: "cesta-pitanja",
    jobs: "zaposljavanje",
    rss: "rss",
    tag: "oznaka",
    press: "mediji",
    unsubscribe: "odjavite-se",
    search: "pretraga",
    airlinesSearch: "zracni-prijevoznici-pretraga",
    airportsSearch: "zracne-luke-pretraga",
    newsSearchResult: "novosti-pretraga-rezultati",
  },
  hu: {
    airlines: "legitarsasagok",
    airline: "legitarsasag",
    browse: "bongeszo",
    flights: "jaratok",
    airports: "repuloterek",
    airport: "repuloter",
    airportHotels: "repuloteri-hotelek",
    country: "orszag",
    dealsFrom: "akcio/innen",
    deals: "akciok",
    news: "hirek",
    archive: "archivum",
    tags: "cimkek",
    aboutWhichairline: "whichairline-rol",
    privacyPolicy: "felhasznalasi-feltetelek",
    contactUs: "kapcsolat",
    mediakit: "mediakit",
    legal: "jog",
    advertise: "hirdetes",
    support: "segitseg",
    faq: "gyik",
    jobs: "allasok",
    rss: "rss",
    tag: "cimke",
    press: "sajto",
    unsubscribe: "leiratkozas",
    search: "kereso",
    airlinesSearch: "legitarsasag-kereso",
    airportsSearch: "repuloter-kereso",
    newsSearchResult: "hirek-kereses-eredmeny",
  },
  id: {
    airlines: "daftar-maskapai-penerbangan",
    airline: "maskapai-penerbangan",
    airlinesSearch: "maskapai-cari",
    browse: "telusur",
    flights: "pesawat",
    airports: "daftar-bandara",
    airport: "bandara",
    airportHotels: "hotel-di-bandara",
    country: "negara",
    airportsSearch: "daftar-bandara-cari",
    dealsFrom: "tiket-termurah/dari",
    deals: "tiket-termurah",
    news: "berita",
    archive: "arsip",
    tags: "label",
    newsSearchResult: "berita-cari-hasil",
    aboutWhichairline: "tentang-kami-whichairline",
    privacyPolicy: "kebijakan-privasi",
    contactUs: "hubungi-kami",
    mediakit: "mediakit",
    legal: "legal",
    advertise: "pemasangan-iklan",
    support: "suport",
    faq: "tanya-jawab",
    jobs: "lowongan",
    rss: "rss",
    tag: "label",
    press: "press",
    unsubscribe: "stop-berlangganan",
    search: "cari",
  },
  it: {
    airlines: "compagnie",
    airline: "compagnia",
    browse: "sfoglia",
    flights: "voli",
    airports: "aeroporti",
    airport: "aeroporto",
    airportHotels: "alberghi-dell-aeroporto",
    country: "pease",
    dealsFrom: "offerte/per",
    deals: "offerte",
    news: "notizie",
    archive: "archivio",
    tags: "tag",
    aboutWhichairline: "info-whichairline",
    privacyPolicy: "politica-privacy",
    contactUs: "contattaci",
    legal: "info-legali",
    mediakit: "mediakit",
    advertise: "promuovi",
    support: "assistenza",
    faq: "domande-frequenti",
    jobs: "lavoro",
    rss: "rss",
    tag: "tag",
    press: "stampa",
    unsubscribe: "disiscriviti",
    search: "ricerca",
    airlinesSearch: "compagnie-ricerca",
    airportsSearch: "aeroporti-ricerca",
    newsSearchResult: "risultati-ricerca-notizie",
  },
  latino: {
    airlines: "aerolineas",
    airline: "aerolinea",
    airlinesSearch: "aerolineas-buscar",
    browse: "explorar",
    flights: "vuelos",
    airports: "aeropuertos",
    airport: "aeropuerto",
    airportHotels: "hoteles-de-aeropuerto",
    country: "pais",
    airportsSearch: "aeropuertos-buscar",
    dealsFrom: "ofertas/desde",
    news: "noticias",
    deals: "ofertas-vuelos",
    archive: "archivo",
    tags: "etiquetas",
    newsSearchResult: "noticias-buscar-resultado",
    aboutWhichairline: "acerca-de-whichairline",
    privacyPolicy: "politica-de-privacidad",
    contactUs: "contactenos",
    legal: "aviso-legal",
    advertise: "anunciar",
    support: "soporte",
    faq: "preguntas-frecuentes",
    jobs: "empleos",
    rss: "rss",
    tag: "etiqueta",
    press: "prensa",
    unsubscribe: "cancelar-suscripcion",
    search: "buscar",
    mediakit: "mediakit",
  },
  nl: {
    airlines: "luchtvaartmaatschappijen",
    airline: "luchtvaartmaatschappij",
    browse: "bladeren",
    flights: "vluchten",
    airports: "luchthavens",
    airport: "luchthaven",
    airportHotels: "luchthavenhotels",
    country: "land",
    dealsFrom: "aanbiedingen/van",
    deals: "aanbiedingen",
    news: "nieuws",
    archive: "archief",
    tags: "tags",
    aboutWhichairline: "over-whichairline",
    privacyPolicy: "privacybeleid",
    contactUs: "contact",
    mediakit: "mediakit",
    legal: "rechtsgeldigheid",
    advertise: "adverteren",
    support: "ondersteuning",
    faq: "veelgestelde-vragen",
    jobs: "vacatures",
    rss: "rss",
    tag: "tag",
    press: "pers",
    unsubscribe: "uitschrijven",
    search: "zoeken",
    airlinesSearch: "luchtvaartmaatschappijen-zoeken",
    airportsSearch: "luchthavens-zoeken",
    newsSearchResult: "nieuws-zoek-resultaat",
  },
  no: {
    airlines: "flyselskaper",
    airline: "flyselskaper",
    browse: "oversikt",
    flights: "flyreiser",
    airports: "flyplasser",
    airport: "flyplass",
    airportHotels: "flyplasshoteller",
    country: "land",
    dealsFrom: "tilbud/fra",
    deals: "tilbud",
    news: "nyheter",
    archive: "arkiv",
    tags: "tagger",
    aboutWhichairline: "om-whichairline",
    privacyPolicy: "personvern",
    contactUs: "kontakt-oss",
    legal: "retningslinjer",
    mediakit: "mediakit",
    advertise: "annonser",
    support: "hjelp",
    faq: "ofte-stilte-sporsmal",
    jobs: "jobbtilbud",
    rss: "rss",
    tag: "tagg",
    press: "nyhetsbrev",
    unsubscribe: "avbestilling",
    search: "sok",
    airlinesSearch: "sok-etter-flyselskaper",
    airportsSearch: "sok-etter-flyplasser",
    newsSearchResult: "sok-etter-nyheter",
  },
  pl: {
    airlines: "linie-lotnicze",
    airline: "linia-lotnicza",
    browse: "przegladanie",
    flights: "loty",
    airports: "lotniska",
    airport: "lotnisko",
    airportHotels: "hotele-w-poblizu-lotniska",
    country: "kraj",
    dealsFrom: "oferty-lotow/z",
    deals: "oferty-lotow",
    news: "nowiny",
    archive: "archiwum",
    tags: "tagi",
    aboutWhichairline: "o-whichairline",
    privacyPolicy: "ochrona-prywatnosci",
    contactUs: "kontakt-z-nami",
    legal: "regulamin",
    mediakit: "mediakit",
    advertise: "reklama",
    support: "pomoc",
    faq: "pytania-i-odpowiedzi",
    jobs: "praca",
    rss: "rss",
    tag: "tag",
    press: "komunikaty-prasowe",
    unsubscribe: "ukonczenie-subskrypcji",
    search: "wyszukiwanie",
    airlinesSearch: "wyszukiwanie-linii-lotniczych",
    airportsSearch: "wyszukiwanie-lotnisk",
    newsSearchResult: "wyniki-wyszukiwania-nowin",
  },
  pt: {
    airlines: "companhias-aereas",
    airline: "companhia-aerea",
    airlinesSearch: "companhias-aereas-pesquisar",
    browse: "pesquisar",
    flights: "voos",
    airports: "aeroportos",
    airport: "aeroporto",
    airportHotels: "hoteis-de-aeroporto",
    country: "pais",
    airportsSearch: "aeroportos-pesquisar",
    dealsFrom: "ofertas/a-partir-de",
    deals: "ofertas",
    news: "noticias",
    archive: "arquivo",
    tags: "etiquetas",
    newsSearchResult: "noticias-pesquisar-resultado",
    aboutWhichairline: "sobre-whichairline",
    privacyPolicy: "politica-privacidade",
    contactUs: "contacte-nos",
    legal: "legal",
    mediakit: "mediakit",
    advertise: "publicidade",
    support: "suporte",
    faq: "perguntas-frequentos",
    jobs: "ofertas-de-emprego",
    rss: "rss",
    tag: "etiqueta",
    press: "imprensa",
    unsubscribe: "nao-subscrever",
    search: "pesquisar",
  },
  ro: {
    airlines: "companii",
    airline: "companie",
    airlinesSearch: "cautare-companii",
    browse: "rasfoire",
    flights: "zboruri",
    airports: "aeroporturi",
    airport: "aeroport",
    airportHotels: "hotelurile-de-la-aeroport",
    country: "tara",
    airportsSearch: "cautare-aeroporturi",
    dealsFrom: "oferte/de-la",
    deals: "oferte-zboruri",
    news: "stiri",
    archive: "arhiva",
    tags: "etichete",
    newsSearchResult: "rezultate-cautare-stiri",
    aboutWhichairline: "despre-whichairline",
    privacyPolicy: "confidentialitate",
    contactUs: "contact",
    mediakit: "mediakit",
    legal: "juridic",
    advertise: "publicitate",
    support: "asistenta",
    faq: "intrebari-frecvente",
    jobs: "joburi",
    rss: "rss",
    tag: "eticheta",
    press: "presa",
    unsubscribe: "dezabonare",
    search: "cautare",
  },
  ru: {
    airlines: "aviakompanii",
    airline: "aviakompanija",
    airlinesSearch: "poisk-aviakompanij",
    browse: "prosmotr",
    flights: "rejsy",
    airports: "ajeroporty",
    airport: "ajeroport",
    airportHotels: "oteli-aeroporta",
    country: "strana",
    airportsSearch: "poisk-ajeroportov",
    dealsFrom: "specpredlozheniya/iz",
    deals: "specpredlozheniya",
    news: "novosti",
    archive: "arhiv",
    tags: "tags",
    newsSearchResult: "rezultat-poiska-novostej",
    aboutWhichairline: "o-whichairline",
    privacyPolicy: "politika-konfidencialnosti",
    contactUs: "kontakty",
    mediakit: "mediakit",
    legal: "juridicheskaja-informacija",
    advertise: "reklama",
    support: "podderzhka",
    faq: "chavo",
    jobs: "vakansii",
    rss: "rss",
    tag: "tag",
    press: "dlja-pressy",
    unsubscribe: "otmena-podpiski",
    search: "poisk",
  },
  sk: {
    airlines: "letecke-spolocnosti",
    airline: "letecka-spolocnost",
    browse: "pismena",
    flights: "letenky",
    airports: "letiska",
    airport: "letisko",
    airportHotels: "hotely-pri-letisku",
    country: "krajina",
    dealsFrom: "akcne-letenky/z",
    deals: "akcne-letenky",
    news: "novinky",
    archive: "archiv",
    tags: "kategoria",
    aboutWhichairline: "o-whichairline",
    privacyPolicy: "ochrana-osobnych-udajov",
    contactUs: "kontaktujte-nas",
    legal: "pravne-otazky",
    mediakit: "mediakit",
    advertise: "inzercia",
    support: "podpora",
    faq: "faq",
    jobs: "ponuka-prace",
    rss: "rss",
    tag: "kategoria",
    press: "press",
    unsubscribe: "unsubscribe",
    search: "hladaj",
    airlinesSearch: "vyhladavanie-leteckych-spolocnosti",
    airportsSearch: "vyhladavanie-letisk",
    newsSearchResult: "vyhladavanie-noviniek",
  },
  sv: {
    airlines: "flygbolag",
    airline: "flygbolag",
    browse: "bladdra",
    flights: "flyg",
    airports: "flygplaster",
    airport: "flygplats",
    airportHotels: "flygplatshotell",
    country: "land",
    dealsFrom: "erbjudanden/fran",
    deals: "erbjudanden",
    news: "nyheter",
    archive: "ariv",
    tags: "taggar",
    aboutWhichairline: "om-whichairline",
    privacyPolicy: "sekretesspolicy",
    contactUs: "kontakta-oss",
    mediakit: "mediakit",
    legal: "juridiskt-meddelande",
    advertise: "annonsera",
    support: "support",
    faq: "spoff",
    jobs: "jobb",
    rss: "rss",
    tag: "tagg",
    press: "press",
    unsubscribe: "avprenumerera",
    search: "sok",
    airlinesSearch: "sok-flygbolag",
    airportsSearch: "sok-flygplatser",
    newsSearchResult: "nyhetssok-resultat",
  },
  tr: {
    airlines: "havayollari",
    airline: "havayolu",
    airlinesSearch: "havayolu-ara",
    browse: "arastir",
    flights: "ucuslar",
    airports: "havaalanlari",
    airport: "havaalani",
    country: "ulkeler",
    airportsSearch: "havaalanlari-ara",
    airportHotels: "havaalani-otelleri",
    dealsFrom: "firsatlar/sehir",
    deals: "firsatlar",
    news: "haberler",
    archive: "arsiv",
    tags: "etiketler",
    newsSearchResult: "haberler-ara-sonuc",
    aboutWhichairline: "hakkinda-whichairline",
    privacyPolicy: "gizlilik-sarti",
    contactUs: "bizimle-iletisim",
    mediakit: "mediakit",
    legal: "yasal",
    advertise: "reklam",
    support: "destek",
    faq: "sss",
    jobs: "isfirsati",
    rss: "rss",
    tag: "etiket",
    press: "basin",
    unsubscribe: "aboneiptal",
    search: "ara",
  },
}

export function getPathForLang(path, locale) {
  const lang = languagesData[locale].translations
  const paths = routesLangs[lang] || routesLangs.en // when not found, use english
  if (paths[path]) {
    return paths[path]
  }
  if (routesLangs.en[path]) {
    return routesLangs.en[path]
  }
  throw new Error(`No such path: ${path}`)
}
